import { render, staticRenderFns } from "./BattleQuestion.vue?vue&type=template&id=9772c086&"
import script from "./BattleQuestion.vue?vue&type=script&lang=js&"
export * from "./BattleQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports